<script setup>
import { CheckCircle2, CircleAlert, Info, TriangleAlert, X } from "@lucide/vue";
import { computed } from "vue";
const props = defineProps({ message: String, type: { type: String, default: "success" }, title: String });
defineEmits(["close"]);
const config = computed(() => ({
  success: { icon: CheckCircle2, title: "Islem tamamlandi", color: "text-emerald-600", bar: "bg-emerald-500" },
  error: { icon: CircleAlert, title: "Islem basarisiz", color: "text-red-600", bar: "bg-red-500" },
  warning: { icon: TriangleAlert, title: "Dikkat", color: "text-amber-600", bar: "bg-amber-500" },
  info: { icon: Info, title: "Bilgi", color: "text-sky-600", bar: "bg-sky-500" },
}[props.type] || { icon: Info, title: "Bilgi", color: "text-sky-600", bar: "bg-sky-500" }));
</script>
<template>
  <Teleport to="body">
    <Transition name="toast-slide">
      <div v-if="message" class="fixed bottom-5 right-5 z-[110] w-[calc(100%-2.5rem)] max-w-sm overflow-hidden rounded-lg border border-slate-200 bg-white shadow-lift">
        <div :class="['h-1 w-full', config.bar]" />
        <div class="flex items-start gap-3 px-4 py-3.5">
          <component :is="config.icon" :class="['mt-0.5 size-5 shrink-0', config.color]" />
          <div class="min-w-0 flex-1">
            <strong class="block text-sm text-ink-950">{{ title || config.title }}</strong>
            <p class="mt-0.5 text-sm leading-5 text-slate-600">{{ message }}</p>
          </div>
          <button type="button" class="rounded p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-700" title="Kapat" @click="$emit('close')"><X class="size-4" /></button>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

